package com.iptvplayer.shared.data.remote.api

import com.iptvplayer.shared.data.remote.dto.*
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.*
import io.ktor.http.*
import com.iptvplayer.shared.util.Constants

class RemoteCommandApi(private val client: HttpClient) {
    suspend fun sendCommand(request: SendCommandRequestDto): RemoteCommandDto =
        client.post("${Constants.BASE_URL}/api/commands") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()

    suspend fun getPendingCommands(deviceId: String): List<RemoteCommandDto> =
        client.get("${Constants.BASE_URL}/api/commands/pending/$deviceId").body()

    suspend fun acknowledgeCommand(request: AckCommandRequestDto): SuccessResponseDto =
        client.post("${Constants.BASE_URL}/api/commands/ack") {
            contentType(ContentType.Application.Json)
            setBody(request)
        }.body()
}
